<template>
  <div class="mr-3">
    <button
      type="button"
      :class="[
        'btn btnclass smallerfontsize ',
        $store.getters[this.getter][this.fieldData.type] ? 'selected' : ''
      ]"
      @click="fieldData.showStartTimeTvModal = true"
    >
      Start time TV
    </button>
    <b-modal
      @ok="saveStartTime"
      @show="showModal"
      @hide="onHidden"
      :no-close-on-backdrop="true"
      v-model="fieldData.showStartTimeTvModal"
      title="Start time TV"
    >
      <div class="form-row">
        <b-form-input
          id="starttime-input"
          class="startTime"
          v-model="startTime"
          placeholder="0200-2559"
          :state="validation.validStartTime"
          size="sm"
          @update="startTimeUpdated"
        />
        <span class="explanation mt-2"
          >Enter the correct format: (0200-2559). For example, 02:00 is written as 0200</span
        >
      </div>
      <template #modal-footer="{ cancel, ok }">
        <b-button size="sm" variant="outline-secondary" @click="cancel()">
          Cancel
        </b-button>
        <b-button
          size="sm"
          :disabled="!validation.validStartTime"
          variant="primary"
          @click="ok()"
        >
        Save
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import props from "@/mixins/inputProps";

export default {
  name: "StartTimeBubbleTv",
  mixins: [props],
  data() {
    return {
      validation: {
        validStartTime: null
      },
      startTime: ""
    };
  },
  methods: {
    showModal() {
      this.startTime = this.$store.getters.getProgramsQuery.start_time_tv ??= "";
      document.addEventListener("keyup", this.onKeyUp);
      this.startTimeUpdated(this.startTime);
    },
    onHidden(e) {
      document.removeEventListener("keyup", this.onKeyUp);
      if (e.trigger === "ok" || e.trigger == "event" || e.trigger === null)
        return;
      let query = this.$store.getters[this.getter];
      let isStartTimeChanged =
        this.title !== query.title || this.wildcard != query.with_wildcards;
      if (isStartTimeChanged) {
        let query = this.$store.getters[this.getter];
        this.wildcard = query.with_wildcards;
        this.title = query.title;
      }
    },
    onKeyUp(event) {
      if (
        event.key === "Enter" &&
        this.fieldData.showStartTimeTvModal &&
        this.validation.validStartTime
      ) {
        this.saveStartTime();
        this.fieldData.showStartTimeTvModal = false;
      }
    },
    startTimeUpdated(startTime) {
      if (startTime.length > 0) {
        let regex = new RegExp(
          "^((?:[01]\\d[0-5][0-9]|2[0-5][0-5][0-9])(?:\\s?)|-(?:\\s?)(?:[01]\\d[0-5][0-9]|2[0-5][0-5][0-9])(?:\\s?,\\s?)?)+$"
        );
        if (startTime.includes("-")) {
          let startTimeFrom = startTime.split("-")[0];
          let startTimeTo = startTime.split("-")[1];

          if (parseInt(startTimeFrom) > parseInt(startTimeTo)) {
            this.validation.validStartTime = false;
            return;
          }
        }
        this.validation.validStartTime = regex.test(startTime);
      } else {
        this.validation.validStartTime = null;
      }
    },
    saveStartTime() {
      const updatedQuery = {
        ...this.$store.getters[this.getter],
        start_time_tv: this.startTime
      };
      this.$store.commit(this.setter, updatedQuery);
    }
  }
};
</script>

<style scoped>
.showMore {
  width: 100%;
  background-color: aliceblue;
  color: #000000;
}
.startTime {
  float: left;
}
</style>
